import React from 'react';

import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';

import moment from 'moment';

function EventCard(props) {
  const { event, index, eventsLength } = props;

  return (
    <>
      <TimelineItem key={index}>
        <TimelineSeparator>
          <TimelineDot />
          {index !== eventsLength - 1 && <TimelineConnector />}
        </TimelineSeparator>
        <TimelineOppositeContent color="textSecondary">
          <div className="flex flex-col justify-center  ">
            {event.allDay ? (
              <span className="flex w-full h-full justify-center items-center  font-bold text-xs text-center bg-white text-black shadow-md rounded-md p-1 border-2 border-[#2E4665]">
                {moment(event.beginDate).format('DD.MM.YYYY')}
              </span>
            ) : (
              <span className="flex w-full h-full justify-center items-center  font-bold text-xs text-center bg-white text-black shadow-md rounded-md p-1 border-2 border-[#2E4665]">
                {moment(event.beginDate).format('DD.MM.YYYY HH:MM')}
              </span>
            )}
            <br />
            {event.allDay ? (
              <span className="flex w-full h-full justify-center items-center  font-bold text-xs text-center bg-white text-black shadow-md rounded-md p-1 border-2 border-[#2E4665]">
                {moment(event.beginDate).format('DD.MM.YYYY')}
              </span>
            ) : (
              <span className="flex w-full h-full justify-center items-center  font-bold text-xs text-center bg-white text-black shadow-md rounded-md p-1 border-2 border-[#2E4665]">
                {moment(event.endDate).format('DD.MM.YYYY HH:MM')}
              </span>
            )}{' '}
            <br />
          </div>
        </TimelineOppositeContent>
        <TimelineContent>
          <div className="w-full h-full flex flex-col justify-center items-center  bg-white shadow-md rounded-md border-2 border-[#2E4665]">
            <span className="font-bold">{event.title}</span>
            <span className="text-xs m-1 text-center">{event.description}</span>
          </div>
        </TimelineContent>
      </TimelineItem>
    </>
  );
}

export default EventCard;
